<p-dialog
  [contentStyle]="{ overflow: 'inherit' }"
  header="{{'Crit_Srch' | translate}}"
  modal="modal"
  [(visible)]="visible"
  [closable]="true"
  (onHide)="closeDia($event)"
  [style]="{width: '50vw'}"
  >
  <div class="grid">
    <form [formGroup]="criteriaForm" class="grid form-group" novalidate>
      <div class="col-12"></div>
      <div class="col-12">
        <span class="p-float-label size_cent">
          <input formControlName="Label" class="p-inputtext size_cent" pInputText type="text" />
          <label>{{'Crit_1' | translate}} * ({{ name }})</label>
        </span>
      </div>
      @if (displayCustom === true) {
        <div class="col-12">
          <p-dropdown
            formControlName="Editor"
            autoWidth="false"
            [showClear]="true"
            [style]="{ width: '100%' }"
            [options]="customEditorList"
            [(ngModel)]="type"
            filter="true"
            placeholder="{{'Sel_Edt' | translate}}"
          ></p-dropdown>
        </div>
      }
      @if (getFieldValue('Type') !== 'DateTime' && getFieldValue('Type') !== 'Date') {
        <div class="col-12">
          <span
            class="p-float-label size_cent"
            >
            <input formControlName="DefaultValue" class="p-inputtext size_cent" pInputText type="text" />
            <label>{{'Val_Def' | translate}}</label>
          </span>
        </div>
      }
      @if (getFieldValue('Type') === 'DateTime' || getFieldValue('Type') === 'Date') {
        <div class="col-12">
          <p-dropdown
            formControlName="DefaultValue"
            autoWidth="false"
            [style]="{ width: '100%' }"
            [options]="criteriaData.ListActionDate"
            [editable]="true"
            (onChange)="onChangeDate($event)"
            placeholder="{{'Sel_OpDt' | translate}}"
          ></p-dropdown>
        </div>
      }
      <div class="col-12">
        <p-dropdown
          formControlName="Operat"
          autoWidth="false"
          [style]="{ width: '100%' }"
          [options]="criteriaData.ListOperators"
          (onChange)="onChangeOperator($event)"
          placeholder="{{'Sel_Op' | translate}}"
        ></p-dropdown>
      </div>
      <div class="col-12">
        <p-checkbox
          formControlName="Visible"
          name="group2"
          binary="true"
          inputId="Includ"
        ></p-checkbox>
        <label for="Includ" class="ml-2">{{'Includ' | translate}}</label>
      </div>
      <div class="col-12">
        <p-checkbox
          formControlName="DisplayDefault"
          name="group2"
          binary="true"
          inputId="Includ_1"
        ></p-checkbox>
        <label for="Includ_1" class="ml-2">{{'Includ_1' | translate}}</label>
      </div>
    </form>
    <div class="col-12 md:col-12 align-right">
      <button class="margin p-button-primary p-button-outlined" type="button" pButton (click)="visible = false" label="{{'Cancel' | translate}}"></button>
      <button class="margin" type="button" pButton (click)="validItem()" label="{{'Valid' | translate}}"></button>
    </div>
  </div>
</p-dialog>
